import React from "react";
import Box from "@mui/material/Box";
import { CircularProgress } from "../../../../components";
import { ReactComponent as LockIcon } from "../../../../assets/lock.svg";
// import LockOverlay from "../../../../components/LockOverlay";

export type TTableRowProps = {
  label: string | React.ReactNode;
  value: string | number | React.ReactNode;
  loading?: boolean;
  lock?: boolean;
  asin?: string;
  lookupId?: string;
};

export const TableRow: React.FC<TTableRowProps> = ({
  label,
  value,
  loading = false,
  // lock = false,
  asin,
  lookupId,
}) => {
  return (
    <Box
      sx={{
        position: "relative",
        borderBottom: "1px solid #181D1F26",
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        minHeight: "29px",
        fontSize: "12px",
        lineHeight: "18px",
        "&:nth-of-type(2n)": {
          background: "#181D1F05",
        },
        "&:last-child": {
          borderBottom: "none",
        },
      }}
    >
      <Box
        sx={{
          fontWeight: 500,
          borderRight: "1px solid #181D1F26",
          padding: "2px 4px",
          color: "#000000",
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
        }}
      >
        {label}
      </Box>
      <Box
        sx={{
          fontWeight: 600,
          display: "flex",
          justifyContent: "end",
          p: "2px 4px",
          flexDirection: "row",
          alignItems: "center",
          color: "#181D27",
        }}
      >
        {loading ? <CircularProgress size="sm" /> : value}
      </Box>
{/* 
      {lock && asin && (
        <LockOverlay
          title={label?.toString()}
          asin={asin}
          lookupId={lookupId}
        />
      )} */}
    </Box>
  );
};

export default TableRow;
